"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityModel = void 0;
const core_1 = require("@angular/core");
const api_1 = require("../../services/api");
let OpportunityModel = class OpportunityModel {
    constructor(api) {
        this.api = api;
        this.getAll = (filter) => __awaiter(this, void 0, void 0, function* () {
            const query = filter ? `?filter=${JSON.stringify(filter)}` : '';
            return this
                .api.get(`/api/opportunities/opportunities${query}`);
        });
        this.get = (opportunityId) => __awaiter(this, void 0, void 0, function* () {
            return this
                .api.get(`/api/opportunities/opportunity/${opportunityId}`);
        });
        this.getForVehicle = (vehicleId) => __awaiter(this, void 0, void 0, function* () {
            return this
                .api.get(`/api/opportunities/vehicle/${vehicleId}`);
        });
        this.delete = (opportunityId) => __awaiter(this, void 0, void 0, function* () { return this.api.delete(`/api/opportunities/opportunity/${opportunityId}`); });
        this.getData = (opportunityId) => __awaiter(this, void 0, void 0, function* () { return this.api.get(`/api/opportunities/data/${opportunityId}`); });
        this.update = (opportunityId, update) => __awaiter(this, void 0, void 0, function* () { return this.api.put(`/api/opportunities/opportunity/${opportunityId}`, update); });
        this.postInfo = (stub) => __awaiter(this, void 0, void 0, function* () { return this.api.post('/api/opportunities/info', stub); });
        this.post = (req) => __awaiter(this, void 0, void 0, function* () { return this.api.post('/api/opportunities/opportunity', req); });
        this.assign = (opportunityId, userId) => __awaiter(this, void 0, void 0, function* () { return this.api.post(`/api/opportunities/assign/${opportunityId}/${userId}`, {}); });
        this.sendEmail = (req) => __awaiter(this, void 0, void 0, function* () { return this.api.post('/api/opportunities/mail', req); });
    }
};
OpportunityModel = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof api_1.ApiService !== "undefined" && api_1.ApiService) === "function" ? _a : Object])
], OpportunityModel);
exports.OpportunityModel = OpportunityModel;
